import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Endpoint, HelpIndex } from '../../../../models/enums';
import { CommonService } from '../../../../services/common/common.service';
import { RestService } from '../../../../services/rest/rest.service';
import { SettingsNavigationContentComponent } from '../../../../models/settings-navigation-content-component';
import { NgForm } from '@angular/forms';
import { ObjectActionListType, ActionType, Permissions } from '../../../../models/permission';

@Component({
    standalone: false,
    selector: 'res-system-message',
    templateUrl: './system-message.component.html',
    styleUrls: ['./system-message.component.scss']
})
export class SystemMessageComponent implements SettingsNavigationContentComponent {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild('contentForm', { static: true }) contentForm: NgForm;
    validChanges = true;

    isBusy = false;
    isBusyMessage = 'Loading ...';
    enableSystemMessage: boolean;
    originalEnableSystemMessage: boolean;
    messageText: string;
    originalMessageText: string;
    hasCreatePermissions: boolean;

    // Methods
    get isDirty(): boolean {
        if (this.contentForm) {
            return this.contentForm.dirty;
        }
        return false;
    }

    set isDirty(value: boolean) {
        if (this.contentForm && this.contentForm.control) {
            if (value) {
                this.contentForm.control.markAsDirty();
            } else {
                this.contentForm.control.markAsPristine();
            }
        }
    }

    constructor(private restService: RestService,
        private commonService: CommonService) { }

    selectedTreeItemChanged(): void {
        this.hasCreatePermissions = Permissions.checkUserPermission(ObjectActionListType.SYSTEM_MESSAGE, ActionType.CREATE);
        this.loadSystemMessageData();
    }

    loadSystemMessageData(): void {
        this.isBusy = true;
        this.isBusyMessage = 'Loading System Message ...';
        this.restService.post(Endpoint.realmManager_getSplashMessage).then(response => {
            this.isBusy = false;
            if (response) {
                this.enableSystemMessage = this.originalEnableSystemMessage = response.enabled;
                this.messageText = this.originalMessageText = response.splashMessage;
            }
            this.isDirty = false;
        }, () => {
            this.isBusy = false;
        });
    }

    onChange(): void {
        this.isDirty = this.originalEnableSystemMessage !== this.enableSystemMessage || this.messageText !== this.originalMessageText;
    }

    discardChanges(): void {
        this.isDirty = false;
        this.loadSystemMessageData();
    }

    saveChanges(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            this.isBusy = true;
            this.isBusyMessage = 'Saving System Message...';
            this.restService.post(Endpoint.realmManager_setSplashMessage, {
                enabled: this.enableSystemMessage,
                splashMessage: this.messageText,
                systemScope: true
            }).then(() => {
                this.isBusy = false;
                this.loadSystemMessageData();
                resolve(true);
            }, error => {
                this.isBusy = false;
                resolve(false);
            });
        });
    }

    openHelp = () => this.commonService.openHelp(HelpIndex.sys_set_system_message_dlg);
}
